import { cleanUpInbox } from '@/entities/orders/thunks/cleanUpInbox'
import { saveOrder } from '@/entities/orders/thunks/saveOrder'
import { fetchScenarios } from '@/entities/schedules'
import { publishScenario } from '@/entities/schedules/thunks/publishScenario'
import { createSlice } from '@reduxjs/toolkit'

import { setupPlanning } from '../thunks/setupPlanning'

export const initialPlanningPageState = {
  isLoading: false,
  isSuccess: false,
  isTreeViewLoading: false,
  orderInboxCount: 0,
}

export const planningPageSlice = createSlice({
  name: 'planningPage',
  initialState: initialPlanningPageState,
  reducers: {
    setOrderInboxCount: (state, action) => {
      state.orderInboxCount = action.payload
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(setupPlanning.pending, (state, _) => {
        state.isLoading = true
        state.isSuccess = false
      })
      .addCase(setupPlanning.fulfilled, (state, _) => {
        state.isLoading = false
        state.isSuccess = true
      })
      .addCase(setupPlanning.rejected, (state, _) => {
        state.isLoading = false
        state.isSuccess = false
      })
      .addCase(fetchScenarios.pending, (state, _) => {
        state.isTreeViewLoading = true
      })
      .addCase(fetchScenarios.fulfilled, (state, _) => {
        state.isTreeViewLoading = false
      })
      .addCase(fetchScenarios.rejected, (state, _) => {
        state.isTreeViewLoading = false
      })
      .addCase(saveOrder.fulfilled, (state, _) => {
        state.orderInboxCount += 1
      })
      .addCase(cleanUpInbox.fulfilled, (state, action) => {
        if (!action.payload) return
        
        state.orderInboxCount = action.payload
      })
      .addCase(publishScenario.fulfilled, (state, action) => {
        if (!action.payload) return
        
        state.orderInboxCount = action.payload
      })
  },
})

export const { setOrderInboxCount } = planningPageSlice.actions